

export default {
  kategoriList: [],
  totalRHRecords: 0
}
